import { MdOutlineFileDownload } from 'react-icons/md';

import { FontSize } from 'commons';
import { Accordion, Loading, Print, Text } from 'components';
import { getUserToken } from 'helpers';
import { useReturnDetails } from 'pages/exchange-and-return/hooks';

import { EntrySummary } from '../components';
import { ProofOfReturn } from './components';
import * as S from './styles';

export function StepCompleted() {
  const { brand } = getUserToken();
  const { returnDetails, consignmentDetails } = useReturnDetails();

  if (!returnDetails || !consignmentDetails) {
    return <Loading />;
  }

  const { entries, isChargedback } = returnDetails;

  return (
    <Accordion title="Confirmação de recebimento" defaultOpen>
      <S.Main>
        <div>
          <Text size={FontSize.font12}>
            <b>Atenção!</b> A devolução do produto abaixo foi confirmada! Um
            e-mail foi enviado ao cliente com o comprovante de estorno anexado e
            informando o prazo de 30 a 60 dias para o estorno.
          </Text>
          <Text size={FontSize.font12}>
            Caso necessário você pode baixar o comprovante de estorno no botão a
            baixo.
          </Text>
        </div>

        {entries.map((summaryEntry, index) => (
          <EntrySummary key={index} summaryEntry={summaryEntry} />
        ))}

        {!isChargedback && (
          <S.ButtonWrapper>
            <S.DownloadButton>
              <Print
                type="button"
                Template={
                  <ProofOfReturn
                    brand={brand}
                    consignmentDetails={consignmentDetails}
                    returnDetails={returnDetails}
                  />
                }
              >
                <S.Icon>
                  <MdOutlineFileDownload />
                </S.Icon>
                Comprovante de estorno
              </Print>
            </S.DownloadButton>
          </S.ButtonWrapper>
        )}
      </S.Main>
    </Accordion>
  );
}
